// extracted by mini-css-extract-plugin
export default {"nav":"menu_nav__cPAUL","navList":"menu_navList__Moln2"};